import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy } from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { ProfileTab } from 'types/interfaces/profile';
import { AssetUrls } from 'config/assets';
import './ProfileTabs.css';

interface ProfileTabsProps {
  activeTab: ProfileTab;
  onTabChange: (tab: ProfileTab) => void;
  showHaveList: boolean;
}

interface TabConfig {
  id: ProfileTab;
  label: string;
  icon?: string;
  faIcon?: IconDefinition;
}

const TABS: TabConfig[] = [
  { id: 'history', label: 'Trade History', icon: 'SendCards/icon-completed.svg' },
  { id: 'want', label: 'Want List', icon: 'heart.svg' },
  { id: 'have', label: 'Have List', icon: 'have.svg' },
  { id: 'trophy-case', label: 'Trophy Case', faIcon: faTrophy },
];

export const ProfileTabs: React.FC<ProfileTabsProps> = ({
  activeTab,
  onTabChange,
  showHaveList,
}) => {
  const visibleTabs = TABS.filter((tab) => tab.id !== 'have' || showHaveList);

  return (
    <div className="profile-tabs">
      {visibleTabs.map((tab) => (
        <button
          key={tab.id}
          className={`profile-tab ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.faIcon ? (
            <FontAwesomeIcon
              icon={tab.faIcon}
              className="profile-tab-icon profile-tab-icon--fa"
            />
          ) : (
            <img
              src={`${AssetUrls.base}/assets/icons/${tab.icon}`}
              alt={tab.label}
              className="profile-tab-icon"
              onError={(e) => {
                (e.target as HTMLImageElement).style.display = 'none';
              }}
            />
          )}
          <span className="profile-tab-label">{tab.label}</span>
        </button>
      ))}
    </div>
  );
};

export default ProfileTabs;
